import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GraduationCap, Play } from "lucide-react";
import { requestTourReplay } from "@/hooks/useOnboarding";

export const ProductTourCard = () => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <GraduationCap className="h-5 w-5 text-primary" />
        Product Tour
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-3">
      <p className="text-sm text-muted-foreground">
        The onboarding walkthrough runs once after signup. Replay it any time for a refresher
        on data import, AI analysis, dashboards and scheduled reports.
      </p>
      <Button variant="outline" onClick={requestTourReplay}>
        <Play className="h-4 w-4 mr-2" />
        Replay tutorial
      </Button>
    </CardContent>
  </Card>
);
